const testimonials = [
  {
    name: 'Maria Silva',
    location: 'Vila Mariana',
    text: 'Serviço impecável! Localizaram o vazamento em minutos e resolveram sem quebrar nada. O laudo foi aceito pela SABESP e consegui abatimento na conta.',
    rating: 5,
    avatar: 'https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=80&h=80&dpr=2'
  },
  {
    name: 'João Santos',
    location: 'Moema',
    text: 'Profissionais muito competentes e educados. Chegaram rápido, identificaram o problema e resolveram no mesmo dia. Super recomendo!',
    rating: 5,
    avatar: 'https://images.pexels.com/photos/1704488/pexels-photo-1704488.jpeg?auto=compress&cs=tinysrgb&w=80&h=80&dpr=2'
  },
  {
    name: 'Ana Paula',
    location: 'Jabaquara',
    text: 'Estava com a conta de água altíssima e não sabia o motivo. A equipe identificou um vazamento escondido e resolveu rapidamente. Excelente custo-benefício!',
    rating: 5,
    avatar: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=80&h=80&dpr=2'
  },
  {
    name: 'Carlos Mendes',
    location: 'Ipiranga',
    text: 'Atendimento excepcional! Detectaram um vazamento que outros profissionais não conseguiram encontrar. Economizei muito na conta de água depois do reparo.',
    rating: 5,
    avatar: 'https://images.pexels.com/photos/1704489/pexels-photo-1704489.jpeg?auto=compress&cs=tinysrgb&w=80&h=80&dpr=2'
  },
  {
    name: 'Fernanda Costa',
    location: 'Vila Olímpia',
    text: 'Equipe muito profissional e pontual. Usaram equipamentos modernos e encontraram o vazamento sem causar nenhum dano. Recomendo de olhos fechados!',
    rating: 5,
    avatar: 'https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=80&h=80&dpr=2'
  },
  {
    name: 'Roberto Lima',
    location: 'Brooklin',
    text: 'Excelente trabalho! Encontraram o vazamento que estava causando infiltração na parede. Serviço rápido e preço justo.',
    rating: 5,
    avatar: 'https://images.pexels.com/photos/1703915/pexels-photo-1703915.jpeg?auto=compress&cs=tinysrgb&w=80&h=80&dpr=2'
  },
  {
    name: 'Luciana Oliveira',
    location: 'Saúde',
    text: 'Muito satisfeita com o atendimento. Resolveram o problema de vazamento na piscina rapidamente e com garantia.',
    rating: 5,
    avatar: 'https://images.pexels.com/photos/3760586/pexels-photo-3760586.jpeg?auto=compress&cs=tinysrgb&w=80&h=80&dpr=2'
  },
  {
    name: 'Eduardo Santos',
    location: 'Campo Belo',
    text: 'Profissionais muito técnicos e honestos. Explicaram todo o processo e entregaram exatamente o que prometeram.',
    rating: 5,
    avatar: 'https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg?auto=compress&cs=tinysrgb&w=80&h=80&dpr=2'
  }
];

type Testimonial = (typeof testimonials)[number];

const renderTestimonialCard = (testimonial: Testimonial, key: string, wrapperClassName: string) => (
  <div key={key} className={`flex-shrink-0 ${wrapperClassName}`}>
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 h-full">
      <div className="flex items-start gap-4 mb-4">
        <img
          src={testimonial.avatar}
          alt={`Foto de ${testimonial.name}`}
          className="w-12 h-12 rounded-full object-cover flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-semibold text-slate-900 text-sm">{testimonial.name}</h3>
          </div>
          <div className="flex gap-1 mb-2">
            {[...Array(testimonial.rating)].map((_, index) => (
              <i key={index} className="ri-star-fill text-yellow-400 text-sm"></i>
            ))}
          </div>
        </div>
      </div>

      <p className="text-slate-600 text-sm leading-relaxed mb-3">“{testimonial.text}”</p>

      <div className="flex items-center gap-1 text-xs text-slate-500">
        <i className="ri-map-pin-line"></i>
        <span>{testimonial.location}</span>
      </div>
    </div>
  </div>
);

export function TestimonialsSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">O que nossos clientes dizem</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Centenas de clientes satisfeitos em toda São Paulo
          </p>
        </div>

        <div className="relative overflow-hidden">
          <div className="hidden md:flex gap-6 animate-marquee-slow">
            {testimonials.map((testimonial, index) =>
              renderTestimonialCard(testimonial, `first-${index}`, 'w-80')
            )}
            {testimonials.map((testimonial, index) =>
              renderTestimonialCard(testimonial, `second-${index}`, 'w-80')
            )}
          </div>

          <div className="-mx-4 md:hidden">
            <div className="flex gap-4 overflow-x-auto px-4 pb-4 snap-x snap-mandatory no-scrollbar">
              {testimonials.map((testimonial, index) =>
                renderTestimonialCard(testimonial, `mobile-${index}`, 'w-72 sm:w-80 snap-start')
              )}
            </div>
          </div>

          {/* Gradientes laterais */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-gray-50 to-transparent z-10 hidden md:block"></div>
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-gray-50 to-transparent z-10 hidden md:block"></div>
        </div>
      </div>
    </section>
  );
}
